import { render, staticRenderFns } from "./ExpenseRow.vue?vue&type=template&id=16940a0e&scoped=true"
import script from "./ExpenseRow.vue?vue&type=script&lang=ts"
export * from "./ExpenseRow.vue?vue&type=script&lang=ts"
import style0 from "./ExpenseRow.vue?vue&type=style&index=0&id=16940a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16940a0e",
  null
  
)

export default component.exports